// src/actions/orders_actions.js
import axios from "axios";
import {
  FETCH_ORDERS_LOADING,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAIL,
  FETCH_ORDER_DETAILS_LOADING,
  FETCH_ORDER_DETAILS_SUCCESS,
  FETCH_ORDER_DETAILS_FAIL,
  SET_ORDERS_PAGE_CURRENT,
  SET_ORDERS_ITEMS_PER_PAGE,
  SET_ORDERS_DATE_RANGE,
  FETCH_ORDERS_COMPARISON_LOADING,
  FETCH_ORDERS_COMPARISON_SUCCESS,
  FETCH_ORDERS_COMPARISON_FAIL,
  FETCH_CHANNEL_ORDERS_LOADING,
  FETCH_CHANNEL_ORDERS_SUCCESS,
  FETCH_CHANNEL_ORDERS_FAIL,
  FETCH_CHANNEL_ORDER_DETAILS_LOADING,
  FETCH_CHANNEL_ORDER_DETAILS_SUCCESS,
  FETCH_CHANNEL_ORDER_DETAILS_FAIL,
  FETCH_CHANNEL_ORDERS_COMPARISON_LOADING,
  FETCH_CHANNEL_ORDERS_COMPARISON_SUCCESS,
  FETCH_CHANNEL_ORDERS_COMPARISON_FAIL,
  SET_CHANNEL_ORDERS_PAGE_CURRENT,
  SET_CHANNEL_ORDERS_ITEMS_PER_PAGE,
  SET_CHANNEL_ORDERS_DATE_RANGE,
  SET_CHANNEL_ORDERS_CURRENCY,
  //Orders Export Page
  FETCH_ORDERS_EXPORT_LOADING,
  FETCH_ORDERS_EXPORT_SUCCESS,
  FETCH_ORDERS_EXPORT_FAIL,
    // Orders product sales (US channel)
  FETCH_ORDERS_PRODUCT_SALES_LOADING,
  FETCH_ORDERS_PRODUCT_SALES_SUCCESS,
  FETCH_ORDERS_PRODUCT_SALES_FAIL,
  FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_LOADING,
  FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_SUCCESS,
  FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_FAIL,
  // Channel (UK/India) product sales
  FETCH_CHANNEL_PRODUCT_SALES_LOADING,
  FETCH_CHANNEL_PRODUCT_SALES_SUCCESS,
  FETCH_CHANNEL_PRODUCT_SALES_FAIL,

  FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_LOADING,
  FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_SUCCESS,
  FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_FAIL,

  // For Channel Orders Filters
  FETCH_ANALYTICS_PRODUCT_OPTIONS_LOADING,
  FETCH_ANALYTICS_PRODUCT_OPTIONS_SUCCESS,
  FETCH_ANALYTICS_PRODUCT_OPTIONS_FAIL,

  //Product Sales Qties
  FETCH_ORDERS_PRODUCT_UNITS_LOADING,
  FETCH_ORDERS_PRODUCT_UNITS_SUCCESS,
  FETCH_ORDERS_PRODUCT_UNITS_FAIL,
  FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_LOADING,
  FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_SUCCESS,
  FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_FAIL,

  FETCH_CHANNEL_PRODUCT_UNITS_LOADING,
  FETCH_CHANNEL_PRODUCT_UNITS_SUCCESS,
  FETCH_CHANNEL_PRODUCT_UNITS_FAIL,
  FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_LOADING,
  FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_SUCCESS,
  FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_FAIL,

  //For HeatMap per State
  FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_LOADING,
  FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_SUCCESS,
  FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_FAIL,
  //Orders New Page Two Period
  FETCH_ORDERS_PRODUCT_COMPARISON_LOADING,
  FETCH_ORDERS_PRODUCT_COMPARISON_SUCCESS,
  FETCH_ORDERS_PRODUCT_COMPARISON_FAIL,

} from "./types";

// Product comparison across TWO custom date ranges (US channel) + OPTIONAL UPC filter
// GET /secureApi/analytics/orders/product-qty-sales-compare-by-upc-date-ranges
// GET /secureApi/analytics/orders/product-qty-sales-compare-by-upc
export const fetchOrdersProductComparisonByUpcDateRanges =
  ({
    dateRange1From,
    dateRange1To,            // ✅ inclusive
    dateRange2From,
    dateRange2To,            // ✅ inclusive

    // backwards-compat support (if some caller still sends these)
    dateRange1ToExclusive,
    dateRange2ToExclusive,

    upcs,
  } = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_ORDERS_PRODUCT_COMPARISON_LOADING });

    const toYmd = (v) => {
      if (!v) return null;
      // Accept "YYYY-MM-DD", or "YYYY-MM-DD 00:00:00", or ISO
      const s = String(v).trim();
      const base = s.split(/[ T]/)[0]; // "YYYY-MM-DD"
      return /^\d{4}-\d{2}-\d{2}$/.test(base) ? base : null;
    };

    const addDaysUtc = (ymdStr, days) => {
      const dt = new Date(`${ymdStr}T00:00:00Z`);
      dt.setUTCDate(dt.getUTCDate() + Number(days || 0));
      return dt.toISOString().slice(0, 10);
    };

    // If someone passed ToExclusive, convert it to inclusive To (exclusive - 1 day)
    const normalizeToInclusive = (toInclusiveMaybe, toExclusiveMaybe) => {
      const inc = toYmd(toInclusiveMaybe);
      if (inc) return inc;

      const exc = toYmd(toExclusiveMaybe);
      if (!exc) return null;

      // exclusive date is the *next day*, so inclusive = exclusive - 1 day
      return addDaysUtc(exc, -1);
    };

    const d1From = toYmd(dateRange1From);
    const d2From = toYmd(dateRange2From);

    const d1To = normalizeToInclusive(dateRange1To, dateRange1ToExclusive);
    const d2To = normalizeToInclusive(dateRange2To, dateRange2ToExclusive);

    try {
      const token = localStorage.getItem("jwtToken");
      const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/product-qty-sales-compare-by-upc`;

      // normalize UPCs into ARRAY + de-dupe (backend expects array => repeated upcs params)
      let upcArr = [];
      if (Array.isArray(upcs)) upcArr = upcs.map((s) => String(s).trim()).filter(Boolean);
      else if (typeof upcs === "string" && upcs.trim().length)
        upcArr = upcs.split(",").map((s) => s.trim()).filter(Boolean);
      upcArr = Array.from(new Set(upcArr));

      const resp = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          dateRange1From: d1From,
          dateRange1To: d1To,   // ✅ correct param name
          dateRange2From: d2From,
          dateRange2To: d2To,   // ✅ correct param name
          ...(upcArr.length ? { upcs: upcArr } : {}),
        },
        paramsSerializer: { indexes: null }, // arrays => upcs=a&upcs=b
      });

      if (resp.data?.success) {
        dispatch({
          type: FETCH_ORDERS_PRODUCT_COMPARISON_SUCCESS,
          payload: resp.data.data,
        });
      } else {
        dispatch({
          type: FETCH_ORDERS_PRODUCT_COMPARISON_FAIL,
          payload: resp.data?.message || "Failed to fetch product comparison",
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_ORDERS_PRODUCT_COMPARISON_FAIL,
        payload: err.response?.data?.message || err.message || "Failed to fetch product comparison",
      });
    }
  };



// Units Heatmap by State (US Channel) + OPTIONAL UPC filter
// GET /secureApi/analytics/orders/units-heatmap-by-state?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD&upcs=...
// channel: "US" (default) or "SHAKERPRO" — same response shape, different source endpoint
export const fetchOrdersUnitsHeatmapByState = (startDate, endDate, upcs, channel = "US") => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const url =
      channel === "SHAKERPRO"
        ? `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/shakerpro/orders/units-heatmap-by-state`
        : `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/units-heatmap-by-state`;

    // normalize UPCs: array OR comma string, de-dupe
    let upcArr = [];
    if (Array.isArray(upcs)) {
      upcArr = upcs.map(String).map((s) => s.trim()).filter(Boolean);
    } else if (typeof upcs === "string") {
      upcArr = upcs.split(",").map((s) => s.trim()).filter(Boolean);
    }
    upcArr = Array.from(new Set(upcArr));

    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        startDate,
        endDate,
        ...(upcArr.length ? { upcs: upcArr } : {}), // ✅ only when set, same logic :contentReference[oaicite:1]{index=1}
      },
      paramsSerializer: { indexes: null }, // ✅ arrays => upcs=a&upcs=b :contentReference[oaicite:2]{index=2}
    });

    if (resp.data?.success) {
      dispatch({
        type: FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_SUCCESS,
        payload: resp.data.data || [],
      });
    } else {
      dispatch({
        type: FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_FAIL,
        payload: resp.data?.message || "Failed to fetch units heatmap by state",
      });
    }
  } catch (err) {
    dispatch({
      type: FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_FAIL,
      payload: err.response?.data?.message || err.message || "Failed to fetch units heatmap by state",
    });
  }
};

//New Qties / Products
// Product units per day (US Channel, range-based) + OPTIONAL UPC filter
// GET /secureApi/analytics/orders/product-units-by-upc-per-day?range=14d&upcs=...
export const fetchOrdersProductUnits = (range = "7d", upcs) => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_PRODUCT_UNITS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/product-units-by-upc-per-day`;

    // normalize UPCs (array or comma string) + de-dupe
    let upcArr = [];
    if (Array.isArray(upcs)) upcArr = upcs.map((s) => String(s).trim()).filter(Boolean);
    else if (typeof upcs === "string" && upcs.trim().length) upcArr = upcs.split(",").map((s) => s.trim()).filter(Boolean);
    upcArr = Array.from(new Set(upcArr));

    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        range: String(range || "7d").toLowerCase(),
        ...(upcArr.length ? { upcs: upcArr.join(",") } : {}),
      },
    });

    if (resp.data?.success) {
      dispatch({ type: FETCH_ORDERS_PRODUCT_UNITS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ORDERS_PRODUCT_UNITS_FAIL, payload: resp.data?.message || "Failed to fetch product units (per day)" });
    }
  } catch (err) {
    dispatch({
      type: FETCH_ORDERS_PRODUCT_UNITS_FAIL,
      payload: err.response?.data?.message || err.message || "Failed to fetch product units (per day)",
    });
  }
};

// Product units by month for a given year (US Channel) + OPTIONAL UPC filter
// GET /secureApi/analytics/orders/product-units-by-month-by-upc?year=2025&upcs=...
export const fetchOrdersProductUnitsByMonth = (year, upcs) => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/product-units-by-month-by-upc`;

    const yearParam =
      typeof year === "number" ? year : parseInt(year, 10) || new Date().getFullYear();

    // normalize UPCs (array or comma string) + de-dupe
    let upcArr = [];
    if (Array.isArray(upcs)) upcArr = upcs.map((s) => String(s).trim()).filter(Boolean);
    else if (typeof upcs === "string" && upcs.trim().length) upcArr = upcs.split(",").map((s) => s.trim()).filter(Boolean);
    upcArr = Array.from(new Set(upcArr));

    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        year: yearParam,
        ...(upcArr.length ? { upcs: upcArr.join(",") } : {}),
      },
    });

    if (resp.data?.success) {
      dispatch({ type: FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_FAIL, payload: resp.data?.message || "Failed to fetch monthly product units" });
    }
  } catch (err) {
    dispatch({
      type: FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_FAIL,
      payload: err.response?.data?.message || err.message || "Failed to fetch monthly product units",
    });
  }
};

// Channel (UK/India) product units (per-day & per-month analytics)
// GET /secureApi/analytics/saleor/channel-product-units-by-sku-per-day?channel=india&range=14d&skus=...
export const fetchChannelProductUnits =
  (channel, range = "7d", skus) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CHANNEL_PRODUCT_UNITS_LOADING });

    try {
      const token = localStorage.getItem("jwtToken");
      const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/channel-product-units-by-sku-per-day`;

      const skuArr = Array.isArray(skus)
        ? skus.map((s) => String(s).trim()).filter(Boolean)
        : (typeof skus === "string" && skus.trim().length)
          ? skus.split(",").map((s) => s.trim()).filter(Boolean)
          : [];

      const resp = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          channel: String(channel || "").toLowerCase(),
          range: String(range || "7d").toLowerCase(),
          ...(skuArr.length ? { skus: skuArr.join(",") } : {}),
        },
      });

      if (resp.data?.success) {
        dispatch({ type: FETCH_CHANNEL_PRODUCT_UNITS_SUCCESS, payload: resp.data.data });
      } else {
        dispatch({ type: FETCH_CHANNEL_PRODUCT_UNITS_FAIL, payload: resp.data?.message || "Failed to fetch channel product units (per day)" });
      }
    } catch (err) {
      dispatch({
        type: FETCH_CHANNEL_PRODUCT_UNITS_FAIL,
        payload: err.response?.data?.message || err.message || "Failed to fetch channel product units (per day)",
      });
    }
  };

  // Channel (UK/India) product units (per-day & per-month analytics)
// GET /secureApi/analytics/saleor/channel-product-units-by-month-by-sku?channel=india&year=2025&skus=...
export const fetchChannelProductUnitsByMonth =
  (channel, year, skus) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_LOADING });

    try {
      const token = localStorage.getItem("jwtToken");
      const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/channel-product-units-by-month-by-sku`;

      const yearParam =
        typeof year === "number" ? year : parseInt(year, 10) || new Date().getFullYear();

      const skuArr = Array.isArray(skus)
        ? skus.map((s) => String(s).trim()).filter(Boolean)
        : (typeof skus === "string" && skus.trim().length)
          ? skus.split(",").map((s) => s.trim()).filter(Boolean)
          : [];

      const resp = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          channel: String(channel || "").toLowerCase(),
          year: yearParam,
          ...(skuArr.length ? { skus: skuArr.join(",") } : {}),
        },
      });

      if (resp.data?.success) {
        dispatch({ type: FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_SUCCESS, payload: resp.data.data });
      } else {
        dispatch({ type: FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_FAIL, payload: resp.data?.message || "Failed to fetch channel product units by month" });
      }
    } catch (err) {
      dispatch({
        type: FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_FAIL,
        payload: err.response?.data?.message || err.message || "Failed to fetch channel product units by month",
      });
    }
  };

export const fetchAnalyticsProductOptions = () => async (dispatch) => {
  dispatch({ type: FETCH_ANALYTICS_PRODUCT_OPTIONS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/products/options`;

    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (resp.data?.success) {
      dispatch({
        type: FETCH_ANALYTICS_PRODUCT_OPTIONS_SUCCESS,
        payload: resp.data.data || [],
      });
    } else {
      dispatch({
        type: FETCH_ANALYTICS_PRODUCT_OPTIONS_FAIL,
        payload: resp.data?.message || "Failed to fetch product options",
      });
    }
  } catch (err) {
    dispatch({
      type: FETCH_ANALYTICS_PRODUCT_OPTIONS_FAIL,
      payload: err.response?.data?.message || err.message || "Failed to fetch product options",
    });
  }
};

// Daily/range endpoint (Saleor)
// NEW endpoint: /secureApi/analytics/saleor/channel-product-sales-by-upc
// Optional filter: skus[] -> sent as query param "upcs"
export const fetchChannelProductSales =
  (channel, range = "7d", skus) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CHANNEL_PRODUCT_SALES_LOADING });

    try {
      const token = localStorage.getItem("jwtToken");
      const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/channel-product-sales-by-upc`;

      // normalize SKUs
      const skuArr = Array.isArray(skus)
        ? skus.map((s) => String(s).trim()).filter(Boolean)
        : (typeof skus === "string" && skus.trim().length)
          ? skus.split(",").map((s) => s.trim()).filter(Boolean)
          : [];

      const resp = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          channel: String(channel || "").toLowerCase(),
          range: String(range || "7d").toLowerCase(),
          ...(skuArr.length ? { upcs: skuArr.join(",") } : {}),
        },
      });

      const { data } = resp;

      if (data && data.success) {
        dispatch({
          type: FETCH_CHANNEL_PRODUCT_SALES_SUCCESS,
          payload: data.data,
        });
      } else {
        dispatch({
          type: FETCH_CHANNEL_PRODUCT_SALES_FAIL,
          payload: data?.message || "Failed to fetch channel product sales",
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CHANNEL_PRODUCT_SALES_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch channel product sales",
      });
    }
  };

// By-month endpoint (Saleor)
// NEW endpoint: /secureApi/analytics/saleor/channel-product-sales-by-month-by-upc
// Optional filter: skus[] -> sent as query param "upcs"
export const fetchChannelProductSalesByMonth =
  (channel, year, skus) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_LOADING });

    try {
      const token = localStorage.getItem("jwtToken");
      const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/channel-product-sales-by-month-by-upc`;

      const yearParam =
        typeof year === "number" ? year : parseInt(year, 10) || new Date().getFullYear();

      // normalize SKUs
      const skuArr = Array.isArray(skus)
        ? skus.map((s) => String(s).trim()).filter(Boolean)
        : (typeof skus === "string" && skus.trim().length)
          ? skus.split(",").map((s) => s.trim()).filter(Boolean)
          : [];

      const resp = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          channel: String(channel || "").toLowerCase(),
          year: yearParam,
          ...(skuArr.length ? { upcs: skuArr.join(",") } : {}),
        },
      });

      const { data } = resp;

      if (data && data.success) {
        dispatch({
          type: FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_SUCCESS,
          payload: data.data,
        });
      } else {
        dispatch({
          type: FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_FAIL,
          payload: data?.message || "Failed to fetch channel product sales by month",
        });
      }
    } catch (error) {
      dispatch({
        type: FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_FAIL,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to fetch channel product sales by month",
      });
    }
  };

// Product sales per day (US Channel, range-based) + OPTIONAL UPC filter
// range: '7 days' | '7d' | '14 days' | '14d' | 'month'
export const fetchOrdersProductSales = (range = "7 days", upcs) => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_PRODUCT_SALES_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/product-sales-by-upc`;

    // normalize UPCs (array or comma string) + de-dupe
    let upcArr = [];
    if (Array.isArray(upcs)) {
      upcArr = upcs.map((s) => String(s).trim()).filter(Boolean);
    } else if (typeof upcs === "string" && upcs.trim().length) {
      upcArr = upcs.split(",").map((s) => s.trim()).filter(Boolean);
    }
    upcArr = Array.from(new Set(upcArr));

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        range,
        ...(upcArr.length ? { upcs: upcArr.join(",") } : {}),
      },
    });

    const { data } = response;

    if (data && data.success) {
      dispatch({
        type: FETCH_ORDERS_PRODUCT_SALES_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: FETCH_ORDERS_PRODUCT_SALES_FAIL,
        payload: data?.message || "Failed to fetch product sales (per day)",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_ORDERS_PRODUCT_SALES_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch product sales (per day)",
    });
  }
};

// Product sales by month for a given year (US Channel) + OPTIONAL UPC filter
export const fetchOrdersProductSalesByMonth = (year, upcs) => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/product-sales-by-month-by-upc`;

    const yearParam =
      typeof year === "number"
        ? year
        : parseInt(year, 10) || new Date().getFullYear();

    // normalize UPCs (array or comma string) + de-dupe
    let upcArr = [];
    if (Array.isArray(upcs)) {
      upcArr = upcs.map((s) => String(s).trim()).filter(Boolean);
    } else if (typeof upcs === "string" && upcs.trim().length) {
      upcArr = upcs.split(",").map((s) => s.trim()).filter(Boolean);
    }
    upcArr = Array.from(new Set(upcArr));

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        year: yearParam,
        ...(upcArr.length ? { upcs: upcArr.join(",") } : {}),
      },
    });

    const { data } = response;

    if (data && data.success) {
      dispatch({
        type: FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_SUCCESS,
        payload: data.data,
      });
    } else {
      dispatch({
        type: FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_FAIL,
        payload: data?.message || "Failed to fetch monthly product sales",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch monthly product sales",
    });
  }
};

// Channel (UK/India) orders
// Helper: choose currency -> explicit arg > Redux state > INR (default)
const pickCurrency = (state, explicit) => {
  if (explicit) return String(explicit).toUpperCase();
  const cur =
    state?.orders?.channel_orders_currency ||      // current reducer key
    
    
    'INR';
  return String(cur).toUpperCase();
};

// ----- Comparison (day|week|month|year OR explicit start/end) -----
export const fetchChannelOrdersComparison = (input, currency, upcs) => async (dispatch, getState) => {
  dispatch({ type: FETCH_CHANNEL_ORDERS_COMPARISON_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    // CHANGED: point to comparison-by-upc
    const url   = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/orders/comparison-by-upc`;

    const params = {};
    if (typeof input === 'string') {
      params.range = input;
    } else if (input && typeof input === 'object') {
      const { range, startTime, endTime } = input;
      if (range)     params.range     = range;
      if (startTime) params.startTime = startTime;
      if (endTime)   params.endTime   = endTime;
    } else {
      params.range = 'month';
    }

    params.currency = pickCurrency(getState(), currency);

    // NEW: pass UPCs/SKUs to comparison endpoint
    if (upcs && (Array.isArray(upcs) ? upcs.length > 0 : String(upcs).trim().length > 0)) {
      params.upcs = Array.isArray(upcs) ? upcs.join(',') : String(upcs).trim();
    }

    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });

    if (resp.data?.success) {
      dispatch({
        type: FETCH_CHANNEL_ORDERS_COMPARISON_SUCCESS,
        payload: resp.data.data
      });
    } else {
      dispatch({
        type: FETCH_CHANNEL_ORDERS_COMPARISON_FAIL,
        payload: resp.data?.message || 'Failed to fetch channel orders comparison'
      });
    }
  } catch (err) {
    dispatch({
      type: FETCH_CHANNEL_ORDERS_COMPARISON_FAIL,
      payload: err.response?.data?.message || err.message || 'Failed to fetch channel orders comparison'
    });
  }
};

// Flat export of orders for explicit date range (startDate/endDate as ISO-like strings)
// channel: "US" (default) or "SHAKERPRO" — same response shape, different source endpoint
export const fetchOrdersExport = (startDate, endDate, channel = "US") => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_EXPORT_LOADING });

  try {
    if (!startDate || !endDate) {
      return dispatch({
        type: FETCH_ORDERS_EXPORT_FAIL,
        payload: "startDate and endDate are required",
      });
    }

    const token = localStorage.getItem("jwtToken");
    const apiUrl =
      channel === "SHAKERPRO"
        ? `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/shakerpro/orders/export`
        : `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/export`;

    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        startDate, // e.g. "2025-08-01" or "2025-08-01T00:00:00"
        endDate,   // e.g. "2025-11-30"
      },
    });

    const { data } = response;

    if (data.success) {
      // backend returns flat array in data.data
      dispatch({
        type: FETCH_ORDERS_EXPORT_SUCCESS,
        payload: data.data || [],
      });
    } else {
      dispatch({
        type: FETCH_ORDERS_EXPORT_FAIL,
        payload: data.message || "Failed to fetch orders export",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_ORDERS_EXPORT_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch orders export",
    });
  }
};


// ----- Paginated orders list -----
export const fetchChannelOrders = (
  startTime,
  endTime,
  page = 1,
  perPage = 20,
  searchTerm = '',
  range = null,
  currency = undefined,
  upcs = undefined       // NEW: optional SKU/UPC filter
) => async (dispatch, getState) => {
  dispatch({ type: FETCH_CHANNEL_ORDERS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    // CHANGED: point to orders-by-upc
    const url   = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/orders-by-upc`;

    const state = getState();
    const params = {
      page,
      perPage,
      currency: pickCurrency(state, currency),
    };

    if (startTime) params.startTime = startTime;
    if (endTime)   params.endTime   = endTime;
    if (range)     params.range     = range;
    if (searchTerm && searchTerm.trim().length >= 3) {
      params.searchTerm = searchTerm.trim();
    }

    // NEW: pass UPCs/SKUs (backend accepts comma-separated or JSON)
    if (upcs && (Array.isArray(upcs) ? upcs.length > 0 : String(upcs).trim().length > 0)) {
      params.upcs = Array.isArray(upcs) ? upcs.join(',') : String(upcs).trim();
    }

    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });

    if (resp.data?.success) {
      dispatch({
        type: FETCH_CHANNEL_ORDERS_SUCCESS,
        payload: {
          orders: resp.data.data || [],
          totalOrders: resp.data.totalOrders || 0,
        },
      });
    } else {
      dispatch({
        type: FETCH_CHANNEL_ORDERS_FAIL,
        payload: resp.data?.message || 'Failed to fetch channel orders'
      });
    }
  } catch (err) {
    dispatch({
      type: FETCH_CHANNEL_ORDERS_FAIL,
      payload: err.response?.data?.message || err.message || 'Failed to fetch channel orders'
    });
  }
};

// ----- Single order details -----
export const fetchChannelOrderDetails = (orderId) => async (dispatch) => {
  dispatch({ type: FETCH_CHANNEL_ORDER_DETAILS_LOADING });
  try {
    const token = localStorage.getItem('jwtToken');
    const url   = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/saleor/order-details/${orderId}`;

    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (resp.data?.success) {
      dispatch({ type: FETCH_CHANNEL_ORDER_DETAILS_SUCCESS, payload: resp.data.data });
    } else {
      dispatch({ type: FETCH_CHANNEL_ORDER_DETAILS_FAIL, payload: resp.data?.message || 'Failed to fetch channel order details' });
    }
  } catch (err) {
    dispatch({ type: FETCH_CHANNEL_ORDER_DETAILS_FAIL, payload: err.response?.data?.message || err.message || 'Failed to fetch channel order details' });
  }
};

// ----- Currency setter (keeps your existing type name) -----
export const setChannelOrdersCurrency = (currency) => ({
  type: SET_CHANNEL_ORDERS_CURRENCY,
  payload: (currency || 'INR').toUpperCase(),
});



// range: 'day' | 'week' | 'month' | 'year'
// range: 'day' | 'week' | 'month' | 'year'
// NEW endpoint: /secureApi/analytics/orders/comparison-by-range-by-upc
export const fetchOrdersComparison = (input) => async (dispatch) => {
  dispatch({ type: FETCH_ORDERS_COMPARISON_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");

    const url = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/comparison-by-range-by-upc`;

    let range = "month";
    let upcs = [];

    if (typeof input === "string") {
      range = input;
    } else if (input && typeof input === "object") {
      if (input.range) range = input.range;

      if (Array.isArray(input.upcs)) {
        upcs = input.upcs;
      } else if (typeof input.upcs === "string") {
        upcs = input.upcs.split(",").map((s) => s.trim()).filter(Boolean);
      }
    }

    // normalize + de-dupe
    upcs = Array.from(new Set(upcs.map((s) => String(s).trim()).filter(Boolean)));

    // IMPORTANT:
    // - send repeated `upcs` params (axios supports arrays => upcs=...&upcs=...)
    // - do NOT send undefined for empty selection
    const resp = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        range,
        ...(upcs.length ? { upcs } : {}), // <— repeated params when array
      },
      // Optional: makes array params serialize as repeated keys; safe with most servers
      paramsSerializer: {
        indexes: null,
      },
    });

    if (resp.data?.success) {
      dispatch({
        type: FETCH_ORDERS_COMPARISON_SUCCESS,
        payload: resp.data.data,
      });
    } else {
      dispatch({
        type: FETCH_ORDERS_COMPARISON_FAIL,
        payload: resp.data?.message || "Failed to fetch comparison",
      });
    }
  } catch (err) {
    dispatch({
      type: FETCH_ORDERS_COMPARISON_FAIL,
      payload: err.response?.data?.message || err.message || "Failed to fetch comparison",
    });
  }
};

export const fetchOrders = (
  startTime,
  endTime,
  page = 1,
  perPage = 20,
  searchTerm = "",
  range = null,              // when truthy → use /paginated-by-range(-by-upc)
  upcs = null,               // NEW: array or comma-separated string
  fulfillmentStatus = null   // Fulfilled | Unfulfilled | Cancelled | Unknown | null (no filter)
                             // Filtered SERVER-SIDE across all four order sources; an
                             // unrecognised value is a 400 from the API, by design.
) => async (dispatch, getState) => {
  dispatch({ type: FETCH_ORDERS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const state = getState();

    // Old behaviour: fall back to Redux dates if not passed (for legacy path)
    const effectiveStart = startTime || state.orders?.orders_date_start;
    const effectiveEnd   = endTime   || state.orders?.orders_date_end;

    const baseUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders`;

    // NEW endpoint for range-based table with optional UPC filtering
    const byRangeByUpcUrl =
      `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/paginated-by-range-by-upc`;

    // legacy range endpoint around only if you we still need it:
    // const byRangeUrl =
    //   `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/orders/paginated-by-range`;

    const useRangeEndpoint = !!range;

    // Normalize UPCs into a clean array
    let upcList = [];
    if (Array.isArray(upcs)) {
      upcList = upcs.map(String).map(s => s.trim()).filter(Boolean);
    } else if (typeof upcs === "string") {
      upcList = upcs.split(",").map(s => s.trim()).filter(Boolean);
    }

    const params = {
      page: Number(page) || 1,
      perPage: Number(perPage) || 20,
    };

    if (useRangeEndpoint) {
      params.range = String(range);

      // Send UPCs only when present (so “no selection” behaves exactly like before)
      if (upcList.length) {
        params.upcs = upcList.join(",");
      }

      // Fulfillment filter — only the range endpoint implements it. Sent only when
      // set, so "All" is byte-identical to the pre-filter request.
      if (fulfillmentStatus) {
        params.fulfillmentStatus = String(fulfillmentStatus);
      }
    } else {
      // legacy explicit window
      if (effectiveStart) params.startTime = effectiveStart;
      if (effectiveEnd)   params.endTime   = effectiveEnd;
    }

    const trimmedSearch = (searchTerm || "").trim();
    if (trimmedSearch.length >= 3) {
      params.searchTerm = trimmedSearch;
    }

    const response = await axios.get(
      useRangeEndpoint ? byRangeByUpcUrl : baseUrl,
      {
        headers: { Authorization: `Bearer ${token}` },
        params,
      }
    );

    const { data } = response;

    if (data && data.success) {
      const orders =
        Array.isArray(data.orders) ? data.orders :
        Array.isArray(data.data)   ? data.data   :
        [];

      const totalOrders =
        typeof data.totalOrders === "number"
          ? data.totalOrders
          : typeof data.total === "number"
            ? data.total
            : orders.length;

      dispatch({
        type: FETCH_ORDERS_SUCCESS,
        payload: { orders, totalOrders },
      });
    } else {
      dispatch({
        type: FETCH_ORDERS_FAIL,
        payload: (data && data.message) || "Failed to fetch orders",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_ORDERS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch orders",
    });
  }
};




// Fetch single order details by orderId
export const fetchOrderDetails = (orderId) => async (dispatch) => {
  const apiUrl = `${process.env.REACT_APP_ADMIN_API_ADDRESS}/secureApi/analytics/order-details/${orderId}`;
  dispatch({ type: FETCH_ORDER_DETAILS_LOADING });

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const { data } = response;
    if (data.success) {
      dispatch({
        type: FETCH_ORDER_DETAILS_SUCCESS,
        payload: data.data
      });
    } else {
      dispatch({
        type: FETCH_ORDER_DETAILS_FAIL,
        payload: data.message || "Failed to fetch order details"
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_ORDER_DETAILS_FAIL,
      payload: error.response?.data?.message || error.message || "Failed to fetch order details"
    });
  }
};

// UI State Setters
export const setOrdersPageCurrent = (page) => ({
  type: SET_ORDERS_PAGE_CURRENT,
  payload: page,
});

export const setOrdersItemsPerPage = (perPage) => ({
  type: SET_ORDERS_ITEMS_PER_PAGE,
  payload: perPage,
});

export const setOrdersDateRange = (start, end) => ({
  type: SET_ORDERS_DATE_RANGE,
  payload: { start, end },
});
